import type { SVGProps } from "react";

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
    className="fill-current"
  >
    <path
      d="M12.9289 7.19202C12.9289 4.02345 10.3606 1.45513 7.19201 1.45513C4.02344 1.45513 1.45513 4.02345 1.45513 7.19202C1.45513 10.3606 4.02344 12.9289 7.19201 12.9289C8.74517 12.9289 10.1527 12.3105 11.1857 11.3081C11.2034 11.2856 11.2226 11.264 11.2433 11.2433C11.2639 11.2228 11.2858 11.2041 11.308 11.1865C12.3108 10.1535 12.9289 8.74539 12.9289 7.19202ZM14.384 7.19202C14.384 8.91583 13.776 10.497 12.7648 11.7358L15.7871 14.7581L15.8368 14.8133C16.0698 15.099 16.0534 15.5208 15.7871 15.7871C15.5208 16.0533 15.0989 16.0698 14.8133 15.8368L14.7581 15.7871L11.7357 12.7648C10.497 13.776 8.91582 14.384 7.19201 14.384C3.22015 14.384 0 11.1639 0 7.19202C0 3.22015 3.22015 0 7.19201 0C11.1639 0 14.384 3.22015 14.384 7.19202Z"
      fill="currentColor"
    />
  </svg>
);
